/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import '../common/time';
import './common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "pricingplan": {
        "nested": {
          "service": {
            "nested": {
              "BannerLocation": {
                "values": {
                  "BANNER_LOCATION_UNKNOWN": 0,
                  "DASHBOARD_HOME": 1,
                  "DASHBOARD_PRICING_AND_SUBSCRIPTIONS": 2
                }
              },
              "BannerType": {
                "values": {
                  "BANNER_TYPE_UNKNOWN": 0,
                  "NO_BANNER": 1,
                  "FINISH_SETUP_FOR_SUBSCRIPTION_V1": 2,
                  "FINISH_SETUP_FOR_SUBSCRIPTION_V2": 3,
                  "FINISH_SETUP_FOR_PAYMENTS": 4,
                  "SUBMIT_SHIPPING_AND_BILLING_INFO": 5,
                  "VERIFY_IDENTITY": 6,
                  "RETURN_HARDWARE": 7,
                  "FINISH_SETUP_FOR_DUAL_MODE_V1": 8,
                  "PRICING_PLAN_V2_EXPIRED": 9,
                  "ADD_PAYMENT_METHOD_FOR_DUAL_MODE_V1": 10,
                  "FINISH_IDV_FOR_DUAL_MODE_V1": 11
                }
              },
              "DetailedLocation": {
                "values": {
                  "DETAILED_LOCATION_UNKNOWN": 0,
                  "TOP_OF_PAGE": 1,
                  "INLINE_SUBSCRIPTION": 2
                }
              },
              "AdditionalLocationData": {
                "fields": {
                  "sub2PlanToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "detailedLocation": {
                    "type": ".squareup.pricingplan.service.DetailedLocation",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ReturnHardwareData": {
                "fields": {
                  "terminationFee": {
                    "type": ".squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "returnBy": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PricingPlanV2ExpiredData": {
                "fields": {
                  "defaultCpFeeRate": {
                    "type": ".squareup.pricingplan.service.FeePlanRate",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "TieredPricingPlanData": {
                "fields": {
                  "targetSub2PlanName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBannerRequest": {
                "fields": {
                  "bannerLocation": {
                    "type": ".squareup.pricingplan.service.BannerLocation",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetBannerResponse": {
                "fields": {
                  "bannerType": {
                    "type": ".squareup.pricingplan.service.BannerType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "additionalLocationData": {
                    "type": ".squareup.pricingplan.service.AdditionalLocationData",
                    "id": 3,
                    "rule": "optional"
                  },
                  "returnHardwareData": {
                    "type": ".squareup.pricingplan.service.ReturnHardwareData",
                    "id": 2
                  },
                  "pricingPlanV2ExpiredData": {
                    "type": ".squareup.pricingplan.service.PricingPlanV2ExpiredData",
                    "id": 4
                  },
                  "tieredPricingPlanData": {
                    "type": ".squareup.pricingplan.service.TieredPricingPlanData",
                    "id": 5
                  }
                },
                "nested": {
                  "banner_data": {
                    "oneof": ["returnHardwareData", "pricingPlanV2ExpiredData", "tieredPricingPlanData"]
                  }
                }
              },
              "PricingPlanHelperService": {
                "methods": {
                  "GetBanner": {
                    "requestType": ".squareup.pricingplan.service.GetBannerRequest",
                    "responseType": ".squareup.pricingplan.service.GetBannerResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.BannerLocation && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.BannerType && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.DetailedLocation && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.AdditionalLocationData && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.ReturnHardwareData && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.PricingPlanV2ExpiredData && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.TieredPricingPlanData && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.GetBannerRequest && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.GetBannerResponse && !$root.nested?.squareup?.nested?.pricingplan?.nested?.service?.nested?.PricingPlanHelperService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BannerLocation @ squareup/pricingplan/externalhelperservice.proto at 14:1
 */
export const BannerLocation = $root.lookupEnum('squareup.pricingplan.service.BannerLocation').values;
/**
 * SOURCE BannerType @ squareup/pricingplan/externalhelperservice.proto at 20:1
 */
export const BannerType = $root.lookupEnum('squareup.pricingplan.service.BannerType').values;
/**
 * SOURCE DetailedLocation @ squareup/pricingplan/externalhelperservice.proto at 35:1
 */
export const DetailedLocation = $root.lookupEnum('squareup.pricingplan.service.DetailedLocation').values;
/**
 * SOURCE AdditionalLocationData @ squareup/pricingplan/externalhelperservice.proto at 41:1
 */
export const AdditionalLocationData = $root.lookupType('squareup.pricingplan.service.AdditionalLocationData');
fixType(AdditionalLocationData);
Builder.createAndAttachToType(AdditionalLocationData);
/**
 * SOURCE ReturnHardwareData @ squareup/pricingplan/externalhelperservice.proto at 51:1
 */
export const ReturnHardwareData = $root.lookupType('squareup.pricingplan.service.ReturnHardwareData');
fixType(ReturnHardwareData);
Builder.createAndAttachToType(ReturnHardwareData);
/**
 * SOURCE PricingPlanV2ExpiredData @ squareup/pricingplan/externalhelperservice.proto at 59:1
 */
export const PricingPlanV2ExpiredData = $root.lookupType('squareup.pricingplan.service.PricingPlanV2ExpiredData');
fixType(PricingPlanV2ExpiredData);
Builder.createAndAttachToType(PricingPlanV2ExpiredData);
/**
 * SOURCE TieredPricingPlanData @ squareup/pricingplan/externalhelperservice.proto at 64:1
 */
export const TieredPricingPlanData = $root.lookupType('squareup.pricingplan.service.TieredPricingPlanData');
fixType(TieredPricingPlanData);
Builder.createAndAttachToType(TieredPricingPlanData);
/**
 * SOURCE GetBannerRequest @ squareup/pricingplan/externalhelperservice.proto at 68:1
 */
export const GetBannerRequest = $root.lookupType('squareup.pricingplan.service.GetBannerRequest');
fixType(GetBannerRequest, {
  bannerLocation: {
    required: true
  }
});
Builder.createAndAttachToType(GetBannerRequest);
/**
 * SOURCE GetBannerResponse @ squareup/pricingplan/externalhelperservice.proto at 72:1
 */
export const GetBannerResponse = $root.lookupType('squareup.pricingplan.service.GetBannerResponse');
fixType(GetBannerResponse, {
  bannerType: {
    required: true
  }
});
Builder.createAndAttachToType(GetBannerResponse);
/**
 * SOURCE PricingPlanHelperService @ squareup/pricingplan/externalhelperservice.proto at 84:1
 */
export const PricingPlanHelperService = $root.lookupService('squareup.pricingplan.service.PricingPlanHelperService');